function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmartphone = function SvgSmartphone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.fill,
    fillRule: "evenodd",
    d: "M8.25 5.75c-.302 0-.5.233-.5.45v11.6c0 .217.198.45.5.45h7.5c.303 0 .5-.233.5-.45V6.2c0-.217-.197-.45-.5-.45zm-2 .45c0-1.103.928-1.95 2-1.95h7.5c1.073 0 2 .847 2 1.95v11.6c0 1.103-.927 1.95-2 1.95h-7.5c-1.072 0-2-.847-2-1.95z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.fill,
    d: "M12 17a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
  }));
};
export default SvgSmartphone;